/*
 * mh-terrassen-ext.js — Erweiterungen fuer den Terrassenplatten-Konfigurator (29.09.2026)
 *
 * Der Kern (terrassen-konfigurator.js) stellt seit dem 29.09.2026 unter #mhKonfRoot.__tk seinen
 * Zustand und seine Funktionen bereit und ruft zwei Haken auf:
 *   root.__tkP(n)          ersetzt die Schrittnavigation (hier: neue Reihenfolge)
 *   window.MH_TK_BOM(h,s)  darf die Materialliste vor Mengenanpassungen veraendern
 * Umgesetzt wird hier:
 *   Punkt 11  Reihenfolge Platte -> Masse & Plan -> Verlegeart -> Aufbauhoehe
 *   Punkt 7   Materialliste und Warenkorb erst im letzten Schritt, Preis immer sichtbar
 *   Punkt 8/9 Speichern & teilen (Anmeldung bei mh-konf-suite.js)
 *   Punkt 12  Aufbauhoehe je Eckpunkt, Stelzlager je Position
 *   Punkt 14  lange Hinweise hinter das i
 */
(function () {
  'use strict';
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
  var NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>';

  function boot() {
    var root = document.getElementById('mhKonfRoot');
    if (!root || !root.__tk || root.__tkExt) return;
    root.__tkExt = true;
    var tk = root.__tk, s = tk.s, D = window.MH_DATA || {};
    function $(q) { return root.querySelector(q); }
    function $$(q) { return Array.prototype.slice.call(root.querySelectorAll(q)); }
    function num(v, d) { return (+v).toLocaleString('de-DE', { minimumFractionDigits: d || 0, maximumFractionDigits: d || 0 }); }
    /* 13.10.2026: Sicherheits-Review (S3) – HTML-Escaping (aus dem Kern, sonst eigene Fassung) */
    var esc = tk.esc || function (t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    function info(el, kurz, title, down) {
      if (!el) return;
      var n = 0;
      (function t() {
        if (window.MHKonf && window.MHKonf.info) { window.MHKonf.info(el, kurz, title, down); return; }
        if (++n < 80) setTimeout(t, 150);
      })();
    }

    /* ================= Punkt 11 + 7: Schrittfolge ================= */
    function order() { return s.verlegeart === 'lose' ? [1, 4, 2] : [1, 4, 2, 3]; }
    function go(n) {
      var ord = order();
      if (ord.indexOf(n) < 0) n = ord[ord.length - 1];
      var p = ord.indexOf(n), last = p === ord.length - 1;
      s.maxPos = Math.max(s.maxPos || 0, p);
      tk.P(n);
      chip();
      s.maxStep = Math.max(s.maxStep || 1, n);
      root.classList.toggle('is-step4', n !== 1);
      root.classList.toggle('mh-last', last);
      $$('.step').forEach(function (b) {
        var i = +b.dataset.step, q = ord.indexOf(i), done = q >= 0 && q < p;
        b.style.display = q < 0 ? 'none' : '';
        b.classList.toggle('active', i === n);
        b.classList.toggle('done', done);
        b.disabled = q < 0 || (q > s.maxPos && !s.platteId);   /* 30.09.2026: nach der Plattenwahl alle Schritte anwählbar */
        var dot = b.querySelector('.sdot'); if (dot) dot.innerHTML = done ? CHECK : String(q + 1);
        var sm = b.querySelector('.slabel small'); if (sm && q >= 0) sm.textContent = 'Schritt ' + (q + 1);
      });
      placeBom(ord[ord.length - 1]);
      /* 02.11.2026: Im letzten Schritt (Zusammenfassung) gibt es kein "Weiter" - nur "Zurück".
         Der Weiter-Knopf des jeweils letzten Panels wird per hidden entfernt (mh-konf-suite.js
         setzt display:inline-flex!important, ein reines style.display griff deshalb nicht). */
      var lastNo = ord[ord.length - 1];
      ['next2', 'next3', 'next4'].forEach(function (id) {
        var b = $('#' + id); if (!b) return;
        var pn = b.closest('[data-panel]'), hide = id === 'next3' || !pn || +pn.getAttribute('data-panel') === lastNo;
        b.hidden = hide; b.style.display = hide ? 'none' : '';
      });
      if (last && s.platteId) tk.render();
      if (n === 3) hcRender();
    }
    /* Plattenchip (#pchip) fuellt der Kern nur beim Betreten von Schritt 2 - der kommt jetzt erst
       nach "Masse & Plan". Kopfzeile (ctTitle) und Chip lesen daraus, also hier selbst fuellen. */
    function chip() {
      var t = s.platteId ? tk.plate(s.platteId) : null, e = $('#pchip');
      if (!e) return;
      if (!t) { e.style.display = 'none'; return; }
      e.style.display = 'flex';
      var l = $('#pchipLabel'), ti = $('#pchipTitle'), su = $('#pchipSub'), sw = $('#pchipSwatch');
      if (l) l.textContent = s.entry === 'pdp' ? 'Von der Produktseite übernommen' : 'Deine Platte';
      if (ti) ti.textContent = 'Terrassenplatte ' + t.title;
      if (su) su.textContent = '· ' + String(t.fmt).replace('x', '×') + ' cm · ab ' + tk.money(t.price) + '/Stk';
      if (sw) { sw.style.background = t.color; sw.style.backgroundImage = "url('" + String(t.img || '').replace(/['"()\\\s]/g, '') + "')"; }   /* 13.10.2026: Sicherheits-Review (S3) – keine Anfuehrungszeichen/Klammern im CSS-URL */
    }
    /* Nur die Aufrufe aus dem Kern laufen hier durch (Plattenwahl, Verlegeart-Wahl); alle
       Knoepfe der Schrittleiste und der Navigation rufen go() direkt auf. */
    root.__tkP = function (n) {
      if (n === 2 && s.step === 1) n = 4;            /* nach der Plattenwahl geht es zu den Massen */
      else if (n === 4 && s.step === 2) n = 2;       /* "Lose Verlegung" gewaehlt: bleibt, ist der letzte Schritt */
      go(n);
    };
    function goF(n) { go(n); }

    /* Stepper in der neuen Reihenfolge */
    var st = $('#stepper');
    if (st) {
      [1, 4, 2, 3].forEach(function (n) {
        var b = st.querySelector('.step[data-step="' + n + '"]'); if (!b) return;
        st.appendChild(b);
        if (n === 4) { var lb = b.querySelector('.slabel b'); if (lb) lb.textContent = 'Maße & Plan'; }
        b.onclick = function () { if (!b.disabled) goF(n); };
      });
    }
    var hp = root.querySelector('.head p'); if (hp) hp.textContent = 'In 4 Schritten zu Verlegeplan, Materialliste und Preis.';

    var p2 = $('[data-panel="2"]'), p3 = $('[data-panel="3"]'), p4 = $('[data-panel="4"]');
    var rg = p4 && p4.querySelector('.res-grid');
    var bomHead = document.createElement('div');
    bomHead.className = 'panel-h mh-bomh';
    bomHead.innerHTML = '<h2>Deine Materialliste</h2><p>Alles für deine Terrasse – Mengen passen sich jeder Änderung an.</p>';
    var bomNote = document.createElement('p');
    bomNote.className = 'helper mh-bomnote';
    function placeBom(panelNo) {
      var pn = $('[data-panel="' + panelNo + '"]');
      if (!pn || !rg || rg.parentNode === pn) return;
      var nav = pn.querySelector('.nav');
      pn.insertBefore(bomHead, nav); pn.insertBefore(rg, nav); pn.insertBefore(bomNote, nav);
    }
    if (p4) {
      var h2 = p4.querySelector('.panel-h h2'), pp = p4.querySelector('.panel-h p');
      if (h2) h2.textContent = 'Deine Maße & dein Verlegeplan';
      if (pp) pp.textContent = 'Form wählen, Maße eingeben – Plan und Preis entstehen sofort.';
      var nav4 = p4.querySelector('.nav');
      if (nav4) {
        var help = nav4.querySelector('.helper');
        if (help) { bomNote.textContent = help.textContent; help.remove(); info(bomNote, 'Mengen sind kalkulierte Richtwerte.', 'So rechnen wir'); }
        var back4 = nav4.querySelector('[data-goto]');
        if (back4) back4.onclick = function () { goF(1); };
        var nx4 = document.createElement('button');
        nx4.type = 'button'; nx4.className = 'btn btn-primary'; nx4.id = 'next4'; nx4.innerHTML = 'Weiter ' + NEXT;
        nx4.onclick = function () { goF(2); };
        nav4.appendChild(nx4);
      }
    }
    if (p2) {
      var back2 = p2.querySelector('.nav [data-goto]');
      if (back2) back2.onclick = function () { goF(4); };
      var n2b = $('#next2'); if (n2b) n2b.onclick = function () { goF(3); };
    }
    if (p3) {
      var back3 = p3.querySelector('.nav [data-goto]');
      if (back3) back3.onclick = function () { goF(2); };
      var n3 = $('#next3'); if (n3) { n3.hidden = true; n3.style.display = 'none'; }
    }
    if (!document.getElementById('mhTkExtCss')) {
      var css = document.createElement('style'); css.id = 'mhTkExtCss';
      css.textContent = '#mhKonfRoot:not(.mh-last) #mctaBtn{display:none}'
        + '#mhKonfRoot .mh-bomh{margin:22px 0 12px;padding-top:18px;border-top:1px solid var(--mhk-line)}'
        + '#mhKonfRoot .mh-bomh h2{font-size:17px;margin:0 0 4px}'
        + '#mhKonfRoot .mh-bomh p{font-size:12.5px;margin:0;color:var(--mhk-ink-soft)}'
        + '#mhKonfRoot .mh-bomnote{display:block;margin:10px 0 0}'
        + '#mhKonfRoot .panel .nav{gap:10px}'
        + '#mhKonfRoot .panel .nav > button.btn-primary[hidden]{display:none!important}'
        + '#mhKonfRoot .mh-hc-body{margin-top:10px}'
        + '#mhKonfRoot .mh-hc-svg{width:100%;max-width:300px;display:block;margin:0 auto 10px;background:var(--mhk-surface-2);border-radius:10px}'
        + '#mhKonfRoot .mh-hc-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(118px,1fr));gap:8px}'
        + '#mhKonfRoot .mh-hc-grid label{display:flex;align-items:center;gap:6px;font-size:12.5px;font-weight:600}'
        + '#mhKonfRoot .mh-hc-grid .num-b{display:inline-flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;background:var(--mhk-orange);color:#fff;font-size:11px;flex:none}'
        + '#mhKonfRoot .mh-hc-grid input{width:70px;padding:6px 8px;border:1px solid var(--mhk-line);border-radius:8px;font:inherit}'
        + '#mhKonfRoot .mh-hc-sum{margin-top:10px;font-size:12.5px;line-height:1.5;color:var(--mhk-ink-soft)}'
        + '#mhKonfRoot .mh-hc-sum b{color:var(--mhk-ink)}'
        + '#mhKonfRoot.mh-hc-on #hPills,#mhKonfRoot.mh-hc-on .hrow{opacity:.45;pointer-events:none}';
      document.head.appendChild(css);
    }

    /* ================= Punkt 14: i-Hinweise ================= */
    var p1 = $('[data-panel="1"]');
    info(p1 && p1.querySelector('.panel-h p'), 'Feinsteinzeug, R11, 2 cm stark.', 'Unsere Platten');
    var kurzArt = { uk: 'Alu-Profile auf Stelzlagern als Tragwerk.', stelz: 'Platten direkt auf Plattenlagern.', lose: 'Lose im Splittbett – ohne Lager.' };
    function choiceTips() {
      $$('#verlegeChoices .choice').forEach(function (c) { var k = kurzArt[c.dataset.art]; if (k) info(c.querySelector('p'), k, c.querySelector('h3') ? c.querySelector('h3').textContent : '', true); });
    }
    setTimeout(choiceTips, 50);
    var ag = $('#ausgleichToggle span'); info(ag, 'dämpft und schont die Kanten', 'Gummi-Ausgleichsscheiben', true);
    info(p4 && p4.querySelector('#freeTools > .helper'), 'Klicken setzt Eckpunkte, Ziehen verschiebt sie.', 'So zeichnest du', true);

    /* ================= Punkt 12: Hoehe je Eckpunkt ================= */
    function shapePts() {
      var L = Math.max(0, s.laenge), B = Math.max(0, s.breite);
      if (s.shape === 'rect') return L > 0 && B > 0 ? [[0, 0], [L, 0], [L, B], [0, B]] : [];
      if (s.shape === 'l') {
        if (L <= 0 || B <= 0) return [];
        var nx = Math.min(Math.max(0, s.notchX), L - .01), ny = Math.min(Math.max(0, s.notchY), B - .01);
        return window.MHL ? MHL.pts(L, B, nx, ny, s.notchC) : [[0, 0], [L, 0], [L, B - ny], [L - nx, B - ny], [L - nx, B], [0, B]];
      }
      return s.poly.length >= 3 ? s.poly.slice() : [];
    }
    function bbOf(pts) { var x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9; pts.forEach(function (p) { x0 = Math.min(x0, p[0]); y0 = Math.min(y0, p[1]); x1 = Math.max(x1, p[0]); y1 = Math.max(y1, p[1]); }); return { x0: x0, y0: y0, x1: x1, y1: y1, w: x1 - x0, h: y1 - y0 }; }
    function inPoly(x, y, pts) {
      var ins = false;
      for (var i = 0, j = pts.length - 1; i < pts.length; j = i++) {
        var xi = pts[i][0], yi = pts[i][1], xj = pts[j][0], yj = pts[j][1];
        if ((yi > y) !== (yj > y) && x < (xj - xi) * (y - yi) / (yj - yi) + xi) ins = !ins;
      }
      return ins;
    }
    function hcState() {
      var pts = shapePts();
      s.hc = s.hc || { on: false, h: [], key: '' };
      var key = s.shape + ':' + pts.length;
      if (s.hc.key !== key) { s.hc.key = key; s.hc.h = pts.map(function () { return s.hoehe; }); }
      return pts;
    }
    function hcAt(x, y, pts) {
      var h = s.hc.h;
      if (s.shape === 'rect' && pts.length === 4) {
        var L = pts[1][0] || 1, B = pts[2][1] || 1, u = Math.min(1, Math.max(0, x / L)), v = Math.min(1, Math.max(0, y / B));
        return h[0] * (1 - u) * (1 - v) + h[1] * u * (1 - v) + h[2] * u * v + h[3] * (1 - u) * v;
      }
      var sw = 0, sv = 0;
      for (var i = 0; i < pts.length; i++) {
        var d2 = (x - pts[i][0]) * (x - pts[i][0]) + (y - pts[i][1]) * (y - pts[i][1]);
        if (d2 < 1e-6) return h[i];
        sw += 1 / d2; sv += h[i] / d2;
      }
      return sw ? sv / sw : s.hoehe;
    }
    function stack() { var st2 = D.settings || {}; return (st2.plateMm || 20) + (s.verlegeart === 'uk' ? (st2.ukMm || 0) : 0); }
    function bands() { return ((D.stelz || {})[s.selbst ? 'selbst' : 'standard']) || []; }
    function classify(hv) {
      var rest = hv - stack(), bs = bands(), band = null, fit = 'ok';
      for (var i = 0; i < bs.length; i++) if (rest >= bs[i].min && rest <= bs[i].max) { band = bs[i]; break; }
      if (!band) {
        if (rest < bs[0].min) { band = bs[0]; fit = 'low'; }
        else if (rest > bs[bs.length - 1].max) { band = bs[bs.length - 1]; fit = 'high'; }
        else { band = bs.filter(function (b) { return b.max >= rest; })[0] || bs[bs.length - 1]; fit = 'gap'; }
      }
      return { band: band, fit: fit, rest: rest };
    }
    function hcGroups() {
      var pts = hcState();
      if (pts.length < 3 || !bands().length) return null;
      var bb = bbOf(pts), stp = .25, groups = {}, tot = 0, lo = 1e9, hi = -1e9;
      if (!(bb.w * bb.h <= 400)) return null;   /* 13.10.2026: Sicherheits-Review (S1) – ueber 400 m² kein Raster */
      for (var y = bb.y0 + stp / 2; y < bb.y1; y += stp) {
        for (var x = bb.x0 + stp / 2; x < bb.x1; x += stp) {
          if (!inPoly(x, y, pts)) continue;
          var hv = hcAt(x, y, pts), c = classify(hv), k = String(c.band.variantId);
          var g = groups[k] || (groups[k] = { n: 0, c: c, min: 1e9, max: -1e9, fits: {} });
          g.n++; tot++; g.fits[c.fit] = 1;
          g.min = Math.min(g.min, hv); g.max = Math.max(g.max, hv); lo = Math.min(lo, hv); hi = Math.max(hi, hv);
        }
      }
      if (!tot) return null;
      return { list: Object.keys(groups).map(function (k) { return groups[k]; }).sort(function (a, b) { return a.min - b.min; }), tot: tot, lo: lo, hi: hi };
    }
    window.MH_TK_BOM = function (h, st2) {
      if (st2 !== s || !s.hc || !s.hc.on || s.verlegeart === 'lose') return;
      var idx = -1;
      h.items.forEach(function (it, i) { if (it.key === 'stelzlager') idx = i; });
      if (idx < 0) return;
      var N = h.items[idx].qty, G = hcGroups();
      if (!G || !(N > 0)) return;
      var alloc = G.list.map(function (g) { var q = N * g.n / G.tot; return { g: g, q: q, f: Math.floor(q) }; });
      var rem = N - alloc.reduce(function (a, x) { return a + x.f; }, 0);
      alloc.slice().sort(function (a, b) { return (b.q - b.f) - (a.q - a.f); }).forEach(function (a) { if (rem > 0) { a.f++; rem--; } });
      var main = alloc.slice().sort(function (a, b) { return b.f - a.f; })[0], k = 0, out = [];
      alloc.forEach(function (a) {
        if (!a.f) return;
        var b = a.g.c.band, warn = a.g.fits.high ? ' · über der größten Stufe!' : a.g.fits.low ? ' · unter der kleinsten Stufe!' : a.g.fits.gap ? ' · teils unter der Mindesthöhe dieser Stufe!' : '';
        out.push({ key: a === main ? 'stelzlager' : 'stelzlager_' + (++k), title: String(b.title) + ' (auf ~' + Math.round(a.g.min - stack()) + '–' + Math.round(a.g.max - stack()) + ' mm)',   /* 13.10.2026: Sicherheits-Review (S3) – Ausgabe escaped der Kern beim Rendern */
          sub: 'Gefälle · ' + a.f + ' Lager bei ' + Math.round(a.g.min) + '–' + Math.round(a.g.max) + ' mm Aufbauhöhe' + warn,
          qty: Number(a.f), unit: 'Stk', price: Number(b.price) || 0, cap: Number(b.cap) || 0, img: b.img, variantId: b.variantId });
      });
      if (!out.length) return;
      h.items.splice.apply(h.items, [idx, 1].concat(out));
      h.hcGroups = G;
    };
    var hcBox = null;
    function hcUI() {
      if (hcBox || !p3) return;
      var anchor = $('#selbstToggle');
      hcBox = document.createElement('div');
      hcBox.id = 'mhHc'; hcBox.className = 'field mh-hc';
      hcBox.innerHTML = '<div class="toggle" id="hcToggle"><div class="tk"></div><div><b>Gefälle: Höhe je Eckpunkt</b><span>Jede Ecke eigene Höhe – Lager werden je Position gewählt</span></div></div>'
        + '<div class="mh-hc-body" hidden><svg class="mh-hc-svg" viewBox="0 0 240 150" aria-hidden="true"></svg><div class="mh-hc-grid"></div><div class="mh-hc-sum"></div></div>';
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(hcBox, anchor); else p3.appendChild(hcBox);
      $('#hcToggle').onclick = function () {
        hcState();
        s.hc.on = !s.hc.on;
        if (s.hc.on) s.hc.h = s.hc.h.map(function () { return s.hoehe; });
        hcRender(); tk.height(); tk.render();
      };
    }
    function slope(pts) {
      var m = 0;
      for (var i = 0; i < pts.length; i++) for (var j = i + 1; j < pts.length; j++) {
        var d = Math.hypot(pts[i][0] - pts[j][0], pts[i][1] - pts[j][1]);
        if (d > .3) m = Math.max(m, Math.abs(s.hc.h[i] - s.hc.h[j]) / (d * 1000) * 100);
      }
      return m;
    }
    function hcRender() {
      hcUI(); if (!hcBox) return;
      var pts = hcState(), on = !!(s.hc && s.hc.on) && pts.length >= 3;
      $('#hcToggle').classList.toggle('on', on);
      root.classList.toggle('mh-hc-on', on);
      var body = hcBox.querySelector('.mh-hc-body');
      body.hidden = !on;
      if (!on) return;
      var bb = bbOf(pts), W = 240, H = 150, pad = 22;
      var k = Math.min((W - 2 * pad) / Math.max(bb.w, .1), (H - 2 * pad) / Math.max(bb.h, .1));
      var ox = (W - bb.w * k) / 2, oy = (H - bb.h * k) / 2;
      function P(p) { return [ox + (p[0] - bb.x0) * k, oy + (p[1] - bb.y0) * k]; }
      var svg = '<polygon points="' + pts.map(function (p) { return P(p).join(','); }).join(' ') + '" fill="#E9E4DA" stroke="#CF6304" stroke-width="1.5"/>';
      pts.forEach(function (p, i) { var q = P(p); svg += '<circle cx="' + q[0] + '" cy="' + q[1] + '" r="9" fill="#EE7402"/><text x="' + q[0] + '" y="' + (q[1] + 3.5) + '" text-anchor="middle" font-size="10" font-weight="700" fill="#fff">' + (i + 1) + '</text>'; });
      hcBox.querySelector('.mh-hc-svg').innerHTML = svg;
      var grid = hcBox.querySelector('.mh-hc-grid');
      if (grid.dataset.n !== String(pts.length)) {
        grid.dataset.n = String(pts.length);
        grid.innerHTML = pts.map(function (p, i) { return '<label><span class="num-b">' + (i + 1) + '</span><input type="number" inputmode="numeric" min="20" max="400" step="1" data-hc="' + i + '"><span>mm</span></label>'; }).join('');
        Array.prototype.forEach.call(grid.querySelectorAll('[data-hc]'), function (inp) {
          inp.addEventListener('change', function () {
            var i = +inp.dataset.hc, v = Math.round(parseFloat(String(inp.value).replace(',', '.')));
            if (!(v > 0)) { inp.value = s.hc.h[i]; return; }
            s.hc.h[i] = Math.max(20, Math.min(400, v));
            s.hoehe = Math.round(s.hc.h.reduce(function (a, b) { return a + b; }, 0) / s.hc.h.length);
            var hi = $('#hoehe'), hs = $('#hSlider'); if (hi) hi.value = s.hoehe; if (hs) hs.value = s.hoehe;
            tk.height(); tk.render(); hcRender();
          });
        });
      }
      Array.prototype.forEach.call(grid.querySelectorAll('[data-hc]'), function (inp) { if (document.activeElement !== inp) inp.value = Math.round(s.hc.h[+inp.dataset.hc]); });
      var G = hcGroups(), sum = hcBox.querySelector('.mh-hc-sum');
      if (!G) { sum.textContent = ''; return; }
      sum.innerHTML = 'Höhen von <b>' + Math.round(G.lo) + '</b> bis <b>' + Math.round(G.hi) + ' mm</b> · Neigung max. ' + num(slope(pts), 1) + ' %<br>'
        + G.list.map(function (g) { return Math.round(g.n / G.tot * 100) + ' %: <b>' + esc(g.c.band.title) + '</b> (' + Math.round(g.min) + '–' + Math.round(g.max) + ' mm)'; }).join('<br>')   /* 13.10.2026: Sicherheits-Review (S3) – Titel escaped */
        + (G.list.some(function (g) { return g.fits.high || g.fits.low || g.fits.gap; }) ? '<br><span style="color:#b3261e">Ein Teil der Fläche liegt außerhalb der Lagerstufen – bitte Höhen prüfen oder Beratung anfragen.</span>' : '');
    }
    hcUI();

    /* 02.10.2026: L-Form - Ecke des Ausschnitts waehlen (A-D) */
    var cs = $('#cornerSeg');
    if (cs) cs.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button[data-c]') : null; if (!b) return;
      s.notchC = /^[ABCD]$/.test(b.dataset.c) ? b.dataset.c : 'C';
      $$('#cornerSeg button').forEach(function (x) { x.classList.toggle('on', x === b); });
      tk.render();
      if (s.hc && s.hc.on) hcRender();
    });
    ['hoehe', 'hSlider'].forEach(function (id) { var el = $('#' + id); if (el) el.addEventListener('input', function () { if (s.hc && s.hc.on) hcRender(); }); });

    /* ================= Punkt 8/9: Speichern & teilen ================= */
    function serialize() {
      if (!s.platteId) return null;
      var o = { v: 1, pl: s.platteId, fm: s.format, va: s.verlegeart, h: s.hoehe, sn: s.selbst ? 1 : 0, sh: s.shape,
        l: s.laenge, b: s.breite, nx: s.notchX, ny: s.notchY, nc: s.notchC || 'C', vg: s.verlegung, gr: s.granulat ? 1 : 0, au: s.ausgleich ? 1 : 0,
        m: s.mods || {}, rm: Object.keys(s.removed || {}).filter(function (k) { return s.removed[k]; }),
        p: (s.poly || []).map(function (q) { return [Math.round(q[0] * 1000) / 1000, Math.round(q[1] * 1000) / 1000]; }) };
      if (s.hc && s.hc.on) o.hc = s.hc.h.map(function (v) { return Math.round(v); });
      return o;
    }
    /* 13.10.2026: Sicherheits-Review (S2) – gespeicherte Planungen kommen aus einem Link bzw. vom
       Server und werden nur in geprueften Grenzen uebernommen: Masse 0,3..100 m, Aussparung 0..100 m,
       Hoehe 20..400 mm, Polygon max. 64 Punkte je 0..100 m (sonst verworfen), Hoehen je Ecke 20..400 mm,
       Mengenanpassungen nur als {base:Zahl, qty:0..9999} unter plausiblen Keys, Auswahlen nur aus der
       vorhandenen Auswahl (Schaltflaechen). Danach die Normalisierung des Kerns (tk.norm). */
    var KEY_RE = /^[a-z0-9_.-]{1,40}$/i;
    function numIn(v, lo, hi, d) { if (typeof v === 'string') v = parseFloat(v.replace(',', '.')); else if (typeof v !== 'number') return d; return isFinite(v) && v >= lo && v <= hi ? v : d; }
    function safeKeys(a) {
      if (!Array.isArray(a)) return [];
      return a.slice(0, 64).filter(function (k) { return typeof k === 'string' && KEY_RE.test(k); });
    }
    function safeMods(m) {
      var out = {};
      if (!m || typeof m !== 'object' || Array.isArray(m)) return out;
      Object.keys(m).slice(0, 64).forEach(function (k) {
        var e = m[k];
        if (!KEY_RE.test(k) || !e || typeof e !== 'object' || Array.isArray(e)) return;
        var base = Number(e.base), qty = Number(e.qty);
        if (!isFinite(base) || !isFinite(qty) || qty !== Math.round(qty) || qty < 0 || qty > 9999) return;
        out[k] = { base: base, qty: qty };
      });
      return out;
    }
    function safePoly(p) {
      if (!Array.isArray(p) || p.length > 64) return [];
      var out = [];
      for (var i = 0; i < p.length; i++) {
        var q = p[i];
        if (!Array.isArray(q) || q.length < 2) return [];
        var x = Number(q[0]), y = Number(q[1]);
        if (!isFinite(x) || !isFinite(y) || x < 0 || x > 100 || y < 0 || y > 100) return [];
        out.push([x, y]);
      }
      return out;
    }
    function hasBtn(sel, attr, v) {
      return typeof v === 'string' && /^[a-z0-9_-]{1,20}$/i.test(v) && !!$(sel + ' button[data-' + attr + '="' + v + '"]');
    }
    function restore(o) {
      var pl = o && typeof o === 'object' && (typeof o.pl === 'string') && tk.plate(o.pl);
      if (!pl) { tk.toast('Diese Planung konnte nicht geladen werden – die Platte ist nicht mehr verfügbar.'); return; }
      s.format = pl.fmt; s.platteId = pl.id; s.entry = 'col';
      tk.fmt(); tk.grid();
      var n1 = $('#next1'); if (n1) n1.disabled = false;
      s.laenge = numIn(o.l, .3, 100, s.laenge); s.breite = numIn(o.b, .3, 100, s.breite);
      s.notchX = numIn(o.nx, 0, 100, s.notchX); s.notchY = numIn(o.ny, 0, 100, s.notchY);
      ['laenge', 'breite', 'notchX', 'notchY'].forEach(function (id) { var el = $('#' + id); if (el) el.value = s[id]; });
      s.notchC = /^[ABCD]$/.test(o.nc) ? o.nc : 'C';
      $$('#cornerSeg button').forEach(function (b) { b.classList.toggle('on', b.dataset.c === s.notchC); });
      s.poly = safePoly(o.p);
      s.verlegung = hasBtn('#laySeg', 'lay', o.vg) ? o.vg : 'auto';
      $$('#laySeg button').forEach(function (b) { b.classList.toggle('on', b.dataset.lay === s.verlegung); });
      s.verlegeart = ['uk', 'stelz', 'lose'].indexOf(o.va) >= 0 && hasBtn('#verlegeChoices', 'art', o.va) ? o.va : 'uk';
      $$('#verlegeChoices .choice').forEach(function (b) { b.classList.toggle('on', b.dataset.art === s.verlegeart); });
      s.hoehe = Math.round(numIn(o.h, 20, 400, s.hoehe)); s.selbst = !!o.sn;
      var hi = $('#hoehe'), hs = $('#hSlider'); if (hi) hi.value = s.hoehe; if (hs) hs.value = s.hoehe;
      $$('#hPills button').forEach(function (b) { b.classList.toggle('on', +b.dataset.h === s.hoehe); });
      s.granulat = o.gr !== 0; s.ausgleich = o.au !== 0;
      s.mods = safeMods(o.m);
      s.removed = {}; safeKeys(o.rm).forEach(function (k) { s.removed[k] = true; });
      var sh = hasBtn('#shapeSeg', 'shape', o.sh) ? o.sh : 'rect';
      var sb = $('#shapeSeg button[data-shape="' + sh + '"]');
      if (sb) sb.click();
      if (tk.norm) tk.norm();
      var pts = shapePts();
      var hc = Array.isArray(o.hc) && o.hc.length === pts.length && pts.length >= 3 ? o.hc.map(function (v) { return numIn(v, 20, 400, NaN); }) : null;
      if (hc && hc.every(function (v) { return isFinite(v); })) s.hc = { on: true, h: hc.map(Math.round), key: s.shape + ':' + pts.length };
      else if (s.hc) s.hc.on = false;
      s.maxPos = order().length - 1;
      tk.height();
      goF(order()[order().length - 1]);
      tk.toast('Deine gespeicherte Planung wurde geladen.');
    }
    function summary() {
      var pl = tk.plate(s.platteId), a = $('#areaVal'), t = $('#totalVal');
      return [pl ? 'Terrassenplatte ' + pl.title : '', a ? a.textContent : '', t ? t.textContent : ''].filter(Boolean).join(', ');
    }
    (window.MHKonfQ = window.MHKonfQ || []).push(['terrassen', { ready: function () { return !!root.__tkExt; }, serialize: serialize, restore: restore, summary: summary }]);

    /* Start: aktuelle Ansicht in der neuen Ordnung zeichnen (Einstieg von der Produktseite: Masse) */
    if (s.step === 2) { s.maxPos = 1; goF(4); }
    else go(s.step || 1);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('mhtk:ready', function () { setTimeout(boot, 0); });
})();